import { useEffect, useState, type ReactNode } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { useSession } from "../features/auth/auth.api.js";
import { useNavModel } from "./nav-model.js";
import { Drawer } from "./Drawer.js";
import { Page } from "../shared/motion.js";

/** Chrome fixe de l'app : barre du haut + drawer. Ne défile jamais. */
export function Shell({ children }: { children: ReactNode }) {
  const { data: user } = useSession();
  const [open, setOpen] = useState(false);
  const path = useRouterState({ select: (s) => s.location.pathname });
  useEffect(() => setOpen(false), [path]);

  const groups = useNavModel(user?.role ?? "client");

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-[#fffdf8]">
      <header className="flex h-14 shrink-0 items-center gap-3 border-b border-stone-200 bg-white/85 px-4 backdrop-blur">
        <button
          onClick={() => setOpen(true)}
          aria-label="Ouvrir le menu"
          className="rounded-lg p-1.5 text-stone-700 transition hover:bg-stone-100"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" />
          </svg>
        </button>
        <Link to="/" className="font-serif text-lg text-stone-900">
          SmartVow
        </Link>
      </header>

      {user && (
        <Drawer open={open} onClose={() => setOpen(false)} groups={groups} userName={user.name} />
      )}

      <main className="min-h-0 flex-1">
        <Page>{children}</Page>
      </main>
    </div>
  );
}
